import {
  ADMIN_ROLE_ID,
  DTS_PRODUCER_ROLE_ID,
  DTS_SUPPORT_ROLE_ID,
  DTS_ASSISTANT_ROLE_ID,
} from '@/utils/constants';
import { trpc } from '@/utils/trpc';
import clsx from 'clsx';
import Link from 'next/link';
import { useRouter } from 'next/router';

export const ADMIN_NAV_ITEMS_MAP = [
  {
    title: 'Projects',
    link: '/admin/projects',
    activePaths: ['/projects'],
    access: [ADMIN_ROLE_ID, DTS_ASSISTANT_ROLE_ID],
  },
  {
    title: 'Visuals',
    link: '/admin/visuals',
    activePaths: ['/visuals'],
    access: [ADMIN_ROLE_ID, DTS_ASSISTANT_ROLE_ID],
  },
  {
    title: 'Creators',
    link: '/admin/creators',
    activePaths: ['/creators'],
    access: [ADMIN_ROLE_ID, DTS_ASSISTANT_ROLE_ID],
  },
  {
    title: 'Members',
    link: '/admin/members',
    activePaths: ['/members'],
    access: [ADMIN_ROLE_ID, DTS_SUPPORT_ROLE_ID],
  },
  {
    title: 'Transactions',
    link: '/admin/transactions',
    activePaths: ['/transactions'],
    access: [ADMIN_ROLE_ID, DTS_SUPPORT_ROLE_ID],
  },
  {
    title: 'IQ Dashboard',
    link: '/admin/dashboard/project-performance',
    activePaths: ['/dashboards'],
    access: [ADMIN_ROLE_ID, DTS_PRODUCER_ROLE_ID, DTS_ASSISTANT_ROLE_ID],
  },
  {
    title: 'Feature Flags',
    link: '/admin/feature-flags',
    activePaths: ['/feature-flags'],
    access: [ADMIN_ROLE_ID],
  },
  {
    title: 'Settings',
    link: '/admin/settings',
    activePaths: ['/settings'],
    access: [ADMIN_ROLE_ID],
  },
  { title: 'Migrate', link: '/admin/migrate', activePaths: ['/migrate'], access: [ADMIN_ROLE_ID] },
  { title: 'Echos', link: '/admin/echos', activePaths: ['/echos'], access: [ADMIN_ROLE_ID] },
];

const AdminNavBar = () => {
  const router = useRouter();
  const { data: roleData } = trpc.users.getUserRole.useQuery();

  const isActivePath = (link: string, activePaths: string[]) =>
    [...activePaths, link]?.some((path) => router.pathname.startsWith(path));

  return (
    <div className="grid grid-cols-5 justify-items-start mb-[70px] mt-[55px]">
      {ADMIN_NAV_ITEMS_MAP.map((item) => {
        if (item.access.length > 0 && !item.access.includes(roleData?.role_id || 0)) {
          return null;
        }
        return (
          <NavItem
            key={item.link}
            title={item.title}
            link={item.link}
            isActive={isActivePath(item.link, item.activePaths)}
          />
        );
      })}
    </div>
  );
};

export default AdminNavBar;

export const NavItem = ({
  title,
  link,
  isActive,
}: {
  title: string;
  link: string;
  isActive: boolean;
}) => {
  return (
    <Link href={link} className="contents">
      <span
        className={clsx(
          "font-normal font-adieu text-sm leading-none tracking-[0.15em] uppercase 3xl:text-sm 4xl:text-[15px] p-[20px] cursor-pointer transition-opacity duration-100 before:content-['('] before:transition-opacity before:duration-100 after:content-[')'] after:transition-opacity after:duration-100",
          isActive
            ? 'opacity-100 before:opacity-100 after:opacity-100'
            : 'opacity-30 hover:opacity-50 before:opacity-0 after:opacity-0'
        )}
      >
        {title}
      </span>
    </Link>
  );
};
